module.exports = __webpack_public_path__ + "static/media/shuffle-flat.76ad9174.svg";